import { Map } from 'immutable';

import Api from './utils/Api';
import store from './store';

import { setRoute } from './modules/routes/actions/set';
import { clear } from './modules/user/actions/clear';

let api = new Api('/api');

api.addObserver((res, data, err) => {
    if (err && err.status === 401) {
        const route = store.getState().routes.get('global') || Map();

        if (route.get('value') === 'login') {
            return;
        }

        store.dispatch(clear());

        store.dispatch(setRoute('global:login', {
            next: 'global:' + route.get('value'),
            params: JSON.stringify((route.get('parameters') || Map()).toJS())
        }));
    }
});

export default api;
